import { logout } from '@/features/auth';
import type { State } from '@/reducers/types';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { retrieveTaaw } from './actions';

const taawsAdapter = createEntityAdapter<any>({
  sortComparer: (a, b) => a.id.localeCompare(b.id),
});

interface TaawsState {
  total: number;
  taawData: any;
  isRegenerated?: boolean;
  title?: string;
}

const initialState = taawsAdapter.getInitialState<TaawsState>({
  total: 0,
  taawData: null,
  isRegenerated: undefined,
  title: undefined,
});

const { name, reducer, actions } = createSlice({
  name: 'taaws',
  initialState,
  reducers: {
    setTaawData(state, action) {
      state.taawData = action.payload;
    },
    setIsRegenerated(state, action) {
      state.isRegenerated = action.payload;
    },
    setTitle(state, action) {
      state.title = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(retrieveTaaw.fulfilled, (state, action) => {
        if (
          action.payload &&
          action.payload.data.type === 'complete' &&
          action.payload.isSecond === true
        ) {
          const success = action.payload.data.updates.find(
            (update: any) => update.type === 'chain-success',
          );
          const successPrev = action.payload.prevData.updates.find(
            (prevUpdate: any) => prevUpdate.type === 'chain-success',
          );
          const answerPrev = successPrev?.output?.output.answer;
          const answer = success?.output?.output.answer;
          const combinedAnswers = answerPrev + '\n\n' + answer;
          state.taawData = combinedAnswers;
        }
      })
      .addCase(logout.fulfilled, () => initialState);
  },
});

const { setTaawData, setIsRegenerated, setTitle } = actions;

export { name, reducer, setIsRegenerated, setTaawData, setTitle };

export const selectTaawData = (state: State) => state[name].taawData;
export const selectTaawIsRegenerated = (state: State) => state[name].isRegenerated;
export const selectTaawTitle = (state: State) => state[name].title;
